import Vue from 'vue';
import VueScrollTo from 'vue-scrollto';

Vue.use(VueScrollTo, {
    offset: -50
});

import AccordionDiv from './components/AccordionDiv.vue';
import OrderCalendar from './components/OrderCalendar.vue';

Vue.component('accordion-div', AccordionDiv);
Vue.component('order-calendar', OrderCalendar);

new Vue({
    el: '#page',

    data: {
        hidden_calendar_event: new Event('hidden-calendar')
    }
});
